import React from "react";
import { Modal, StyleSheet, TouchableOpacity } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import CloseIcon from "@assets/svg/CloseIcon";

/**
 * Full-screen, edge-to-edge video/banner overlay.
 *
 * Renders in a translucent Modal window (its own window, so it draws full-bleed
 * behind the system bars). The SafeAreaView is the single source of truth for the
 * top/bottom insets — the close button is offset by a plain `top: 20` relative to
 * that safe area, so there is no `StatusBar.currentHeight` double-counting.
 *
 * Pass the video/player as children.
 */
const VideoOverlayModal = ({
  visible,
  onClose,
  onRequestClose,
  children,
  hideClose = false,
  testID,
  closeTestID,
}) => (
  <Modal
    visible={visible}
    transparent
    statusBarTranslucent
    navigationBarTranslucent
    onRequestClose={onRequestClose || onClose}
  >
    <SafeAreaView edges={["top", "bottom"]} style={styles.container} testID={testID}>
      {!hideClose && (
        <TouchableOpacity
          testID={closeTestID}
          onPress={onClose}
          style={styles.close}
        >
          <CloseIcon fill="#fff" />
        </TouchableOpacity>
      )}
      {children}
    </SafeAreaView>
  </Modal>
);

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#000000",
    justifyContent: "center",
  },
  close: {
    // SafeAreaView already offsets content by the top inset, so this is a plain
    // offset from the safe area — never StatusBar.currentHeight (edge-to-edge safe).
    position: "absolute",
    top: 20,
    right: 23,
    zIndex: 5,
  },
});

export default VideoOverlayModal;
